import { religionFullList } from "features/cliams/utils";
import { handlePreauthFormData as handlePreauthFormDataPreauth } from "features/preauthorization/config/preauthorizationSlice";

import { handlePreauthFormData as handlePreauthFormDataClaim } from "features/cliams/config/claimSlice";

import { getToday } from "helpers/utils";
import React from "react";
import { Modal, Accordion, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { handleResetPatientSearch } from "../config/eligibilityCheckSlice";

const EligibilityCCHIModal = ({
  show,
  handleClose,
  setValue,
  watch,
  frompreauth = false,
  fromclaim = false,
}) => {
  const dispatch = useDispatch();
  const {
    insuranceList,
    genderList,
    maritalList,
    relationshipList,
    professionList,
    processPriorityList,
    nationalityList,
    purposeList,
    patientSearchData,
    identifierTypeList,
  } = useSelector((state) => state.eligibilityCheck);

  // Compute default active keys to expand all by default
  const defaultActiveKeys =
    patientSearchData?.map((_, index) => index.toString()) || [];

  const handleSelected = (item) => {
    setValue("marital_status", null);
    setValue("occupation", null);
    setValue("patient_mrn", item?.patient_mrn);
    setValue(
      "identifier_type",
      nationalityList?.find((i) => i?.ident_type_name == item?.ident_type_name)
    );
    setValue("first_name", item?.patient_firstname);
    setValue("family_name", item?.patient_familyname);
    setValue("birth_date", item?.patient_dob);
    setValue(
      "gender",
      genderList?.find((i) => i?.genders_code === item?.genders_code)
    );
    setValue(
      "marital_status",
      item?.maritalstatus_code
        ? maritalList?.find(
            (i) => i?.maritalstatus_code === item?.maritalstatus_code
          )
        : null
    );
    setValue(
      "profession",
      professionList?.find((i) => i?.occup_code === item?.occup_code)
    );
    setValue(
      "occupation",
      professionList?.find((i) => i?.occup_code === item?.occup_code)
    );

    setValue(
      "insurance",
      insuranceList?.find(
        (i) => i?.insurance_company_id === item?.insurance_company_id
      )
    );
    setValue(
      "identifier_type",
      identifierTypeList?.find((i) => i?.ident_type_id === item?.ident_type_id)
    );
    setValue(
      "religion",
      religionFullList?.find((i) => i?.religion_code === item?.religion_code)
    );
    setValue("member_id", item?.patient_ins_memid);
    setValue("network", item?.patient_ins_network);
    setValue("policy_holder", item?.patpolcy_name);
    setValue("policy_holder_name", item?.patpolcy_name);
    setValue("policy_no", item?.patient_ins_polynum);
    setValue("class_name", item?.patient_ins_clsnme);
    setValue("id", item?.patient_nationalid);

    setValue(
      "relationship",
      watch("new_born")
        ? relationshipList?.find((i) => i?.patrtl_code === "child")
        : relationshipList?.find((i) => i?.patrtl_code === "self")
    );
    setValue(
      "process_priority",
      processPriorityList?.find((i) => i?.prcspri_code === "normal")
    );

    setValue("service_period_from_date", getToday());
    // Create array of all purposes
    const allPurposes = purposeList.map((item) => ({
      value: item.eligbpurp_code,
      label: item.eligbpurp_name,
    }));

    // Update form value without triggering validation
    setValue("purpose", allPurposes, { shouldValidate: false });

    handleClose();
    const data = {
      patient_mrn: item?.patient_mrn,
      first_name: item?.patient_firstname,
      family_name: item?.patient_familyname,
      birth_date: item?.patient_dob,
      id: item?.patient_nationalid,
      gender: genderList?.find(
        (i) => i?.genders_code === item?.genders_code || ""
      ),
      marital_status: item?.maritalstatus_code
        ? maritalList?.find(
            (i) => i?.maritalstatus_code === item?.maritalstatus_code
          )
        : null,
      occupation: professionList?.find(
        (i) => i?.occup_code === item?.occup_code || ""
      ),
      payer: insuranceList?.filter(
        (i) => i?.insurance_company_id === item?.insurance_company_id
      )[0],
      identifier_type: identifierTypeList?.find(
        (i) => i?.ident_type_id === item?.ident_type_id
      ),
      relationship: watch("new_born")
        ? relationshipList?.find((i) => i?.patrtl_code === "child")
        : relationshipList?.find((i) => i?.patrtl_code === "self"),
      member_id: item?.patient_ins_memid,
      network: item?.patient_ins_network,
      policy_holder_name: item?.patpolcy_name,
      policy_no: item?.patient_ins_polynum,
      class_name: item?.patient_ins_clsnme,
    };
    if (frompreauth) {
      dispatch(handlePreauthFormDataPreauth({ check: "save", data }));
      dispatch(handleResetPatientSearch());
    } else if (fromclaim) {
      dispatch(handlePreauthFormDataClaim({ check: "save", data }));
      dispatch(handleResetPatientSearch());
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-10 text-primary">Payer List</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <Accordion alwaysOpen defaultActiveKey={defaultActiveKeys}>
          {patientSearchData &&
            patientSearchData?.length > 0 &&
            patientSearchData?.map((item, index) => (
              <Accordion.Item
                eventKey={index.toString()}
                key={item.patient_ins_memid || index}
                className="mb-3 border rounded"
              >
                <Accordion.Header className="d-flex align-items-center gap-1">
                  <Form.Check
                    type="checkbox"
                    className="me-2"
                    disabled={!item?.insurance_company_id}
                    onChange={(e) => {
                      if (e.target.checked) {
                        handleSelected(item);
                      }
                    }}
                  />
                  {item.insurance_company_name}{" "}
                  {!item?.insurance_company_id && (
                    <span className="text-danger ml-2 fs-10">
                      (Insurance Not Active in this Branch)
                    </span>
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  <div
                    className={`d-grid gap-2`}
                    style={{ gridTemplateColumns: "repeat(3, 1fr)" }}
                  >
                    <div>
                      <strong className="text-primary fs-10">
                        Beneficiary Name
                      </strong>
                      <div className="text-danger fs-11">{`${item.patient_firstname} ${item.patient_familyname}`}</div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">
                        Beneficiary MRN
                      </strong>
                      <div className="text-danger fs-11">
                        {item?.patient_mrn}
                      </div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">
                        Beneficiary Type
                      </strong>
                      <div className="text-danger fs-11">
                        {item.ident_type_name}
                      </div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">
                        Identifier Number
                      </strong>
                      <div className="text-danger fs-11">
                        {item.patient_nationalid}
                      </div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">Class Name</strong>
                      <div className="text-danger fs-11">
                        {item.patient_ins_clsnme}
                      </div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">
                        Memebership ID
                      </strong>
                      <div className="text-danger fs-11">
                        {item.patient_ins_memid}
                      </div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">Policy No.</strong>
                      <div className="text-danger fs-11">
                        {item.patpolcy_number}
                      </div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">
                        Policy Holder Name
                      </strong>
                      <div className="text-danger fs-11">
                        {item.patpolcy_name}
                      </div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">Network</strong>
                      <div className="text-danger fs-11">
                        {item.patient_ins_network}
                      </div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">Gender</strong>
                      <div className="text-danger fs-11">
                        {item.genders_disply}
                      </div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">Occupation</strong>
                      <div className="text-danger fs-11">
                        {item.occup_disply}
                      </div>
                    </div>
                    <div>
                      <strong className="text-primary fs-10">Religion</strong>
                      <div className="text-danger fs-11">
                        {item.religion_name}
                      </div>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
        </Accordion>
      </Modal.Body>
    </Modal>
  );
};

export default EligibilityCCHIModal;
